import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import BrandIcon from "../BrandIcon";
import i18next from "i18next";
import PlatformImage from "../PlatformImage";
export var BrandHeaderLogo = function BrandHeaderLogo(props) {
  var isReservationLogoFromUrl = i18next.exists("brand_header_logo_url") && i18next.t("brand_header_logo_url");

  if (isReservationLogoFromUrl !== null && isReservationLogoFromUrl !== void 0 && isReservationLogoFromUrl.length) {
    return /*#__PURE__*/_jsx(PlatformImage, _objectSpread(_objectSpread({
      imageUri: isReservationLogoFromUrl
    }, props), {}, {
      resizeMode: "contain"
    }));
  }

  return /*#__PURE__*/_jsx(BrandIcon, _objectSpread({
    iconName: props === null || props === void 0 ? void 0 : props.iconName
  }, props));
};